var _ellipse, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _path, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreckle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 294,
    viewBox: "0 0 324 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.802,
    cy: 148.863,
    rx: 156.802,
    ry: 145.137,
    fill: "#B4805E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7367 154.039C63.7367 163.873 55.1241 171.845 44.4999 171.845C33.8757 171.845 25.2631 163.873 25.2631 154.039C25.2631 144.206 33.8757 136.234 44.4999 136.234C55.1241 136.234 63.7367 144.206 63.7367 154.039Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.184 75.3633C183.184 85.1971 174.571 93.169 163.947 93.169C153.323 93.169 144.71 85.1971 144.71 75.3633C144.71 65.5296 153.323 57.5577 163.947 57.5577C174.571 57.5577 183.184 65.5296 183.184 75.3633Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.368 53.4169C279.368 63.2507 270.755 71.2225 260.131 71.2225C249.507 71.2225 240.894 63.2507 240.894 53.4169C240.894 43.5831 249.507 35.6113 260.131 35.6113C270.755 35.6113 279.368 43.5831 279.368 53.4169Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.842 234.372C283.842 244.206 275.229 252.178 264.605 252.178C253.981 252.178 245.368 244.206 245.368 234.372C245.368 224.538 253.981 216.566 264.605 216.566C275.229 216.566 283.842 224.538 283.842 234.372Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.447 184.268C172.447 194.101 163.835 202.073 153.21 202.073C142.586 202.073 133.974 194.101 133.974 184.268C133.974 174.434 142.586 166.462 153.21 166.462C163.835 166.462 172.447 174.434 172.447 184.268Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 42.2367C104 52.0704 95.3872 60.0423 84.7629 60.0423C74.1387 60.0423 65.5261 52.0704 65.5261 42.2367C65.5261 32.4029 74.1387 24.431 84.7629 24.431C95.3872 24.431 104 32.4029 104 42.2367Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.684 35.6113C191.684 45.445 183.071 53.4169 172.447 53.4169C161.823 53.4169 153.21 45.445 153.21 35.6113C153.21 25.7775 161.823 17.8056 172.447 17.8056C183.071 17.8056 191.684 25.7775 191.684 35.6113Z",
    fill: "#EE6666"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.763 97.3099C84.763 107.144 76.1503 115.116 65.5261 115.116C54.9019 115.116 46.2893 107.144 46.2893 97.3099C46.2893 87.4761 54.9019 79.5043 65.5261 79.5043C76.1503 79.5043 84.763 87.4761 84.763 97.3099Z",
    fill: "#EE6666"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.421 264.186C151.421 274.02 142.808 281.992 132.184 281.992C121.56 281.992 112.947 274.02 112.947 264.186C112.947 254.352 121.56 246.38 132.184 246.38C142.808 246.38 151.421 254.352 151.421 264.186Z",
    fill: "#EE6666"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.421 178.056C304.421 187.89 295.808 195.862 285.184 195.862C274.56 195.862 265.947 187.89 265.947 178.056C265.947 168.223 274.56 160.251 285.184 160.251C295.808 160.251 304.421 168.223 304.421 178.056Z",
    fill: "#EE6666"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4473 195.862C70.4473 205.696 61.8347 213.668 51.2105 213.668C40.5863 213.668 31.9736 205.696 31.9736 195.862C31.9736 186.028 40.5863 178.056 51.2105 178.056C61.8347 178.056 70.4473 186.028 70.4473 195.862Z",
    fill: "#74D984"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.789 17.8056C139.789 27.6394 131.177 35.6113 120.552 35.6113C109.928 35.6113 101.316 27.6394 101.316 17.8056C101.316 7.97185 109.928 0 120.552 0C131.177 0 139.789 7.97185 139.789 17.8056Z",
    fill: "#74D984"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.315 130.022C322.315 139.856 313.703 147.828 303.079 147.828C292.454 147.828 283.842 139.856 283.842 130.022C283.842 120.189 292.454 112.217 303.079 112.217C313.703 112.217 322.315 120.189 322.315 130.022Z",
    fill: "#74D984"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.894 267.084C223.894 276.918 215.282 284.89 204.658 284.89C194.033 284.89 185.421 276.918 185.421 267.084C185.421 257.251 194.033 249.279 204.658 249.279C215.282 249.279 223.894 257.251 223.894 267.084Z",
    fill: "#74D984"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.474 213.668C125.474 223.501 116.861 231.473 106.237 231.473C95.6125 231.473 86.9999 223.501 86.9999 213.668C86.9999 203.834 95.6125 195.862 106.237 195.862C116.861 195.862 125.474 203.834 125.474 213.668Z",
    fill: "#65B2FA"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.158 112.217C230.158 122.051 221.545 130.023 210.921 130.023C200.297 130.023 191.684 122.051 191.684 112.217C191.684 102.383 200.297 94.4113 210.921 94.4113C221.545 94.4113 230.158 102.383 230.158 112.217Z",
    fill: "#65B2FA"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4735 110.975C40.4735 120.808 31.8609 128.78 21.2367 128.78C10.6125 128.78 1.99988 120.808 1.99988 110.975C1.99988 101.141 10.6125 93.1689 21.2367 93.1689C31.8609 93.1689 40.4735 101.141 40.4735 110.975Z",
    fill: "#65B2FA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.368 195.862C245.368 205.696 236.755 213.668 226.131 213.668C215.507 213.668 206.894 205.696 206.894 195.862C206.894 186.028 215.507 178.056 226.131 178.056C236.755 178.056 245.368 186.028 245.368 195.862Z",
    fill: "#F0AFE6"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9473 249.279C78.9473 259.113 70.3347 267.085 59.7105 267.085C49.0863 267.085 40.4736 259.113 40.4736 249.279C40.4736 239.445 49.0863 231.473 59.7105 231.473C70.3347 231.473 78.9473 239.445 78.9473 249.279Z",
    fill: "#F0AFE6"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.026 115.115C159.026 124.949 150.414 132.921 139.789 132.921C129.165 132.921 120.552 124.949 120.552 115.115C120.552 105.282 129.165 97.3098 139.789 97.3098C150.414 97.3098 159.026 105.282 159.026 115.115Z",
    fill: "#F0AFE6"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.631 136.234C268.631 146.068 260.019 154.039 249.394 154.039C238.77 154.039 230.158 146.068 230.158 136.234C230.158 126.4 238.77 118.428 249.394 118.428C260.019 118.428 268.631 126.4 268.631 136.234Z",
    fill: "#F2E785"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.421 115.115C117.421 124.949 108.808 132.921 98.1841 132.921C87.5599 132.921 78.9473 124.949 78.9473 115.115C78.9473 105.282 87.5599 97.3098 98.1841 97.3098C108.808 97.3098 117.421 105.282 117.421 115.115Z",
    fill: "#F2E785"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.684 225.676C191.684 235.51 183.071 243.482 172.447 243.482C161.823 243.482 153.21 235.51 153.21 225.676C153.21 215.842 161.823 207.87 172.447 207.87C183.071 207.87 191.684 215.842 191.684 225.676Z",
    fill: "#F2E785"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.895 160.251C206.895 170.084 198.282 178.056 187.658 178.056C177.034 178.056 168.421 170.084 168.421 160.251C168.421 150.417 177.034 142.445 187.658 142.445C198.282 142.445 206.895 150.417 206.895 160.251Z",
    fill: "#EFA25B"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.421 165.634C117.421 175.468 108.808 183.439 98.1841 183.439C87.5599 183.439 78.9473 175.468 78.9473 165.634C78.9473 155.8 87.5599 147.828 98.1841 147.828C108.808 147.828 117.421 155.8 117.421 165.634Z",
    fill: "#EFA25B"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_92_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.368 89.0281C262.368 98.8619 253.755 106.834 243.131 106.834C232.507 106.834 223.894 98.8619 223.894 89.0281C223.894 79.1944 232.507 71.2225 243.131 71.2225C253.755 71.2225 262.368 79.1944 262.368 89.0281Z",
    fill: "#EFA25B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7103 202.073C112.161 217.994 134.601 227.332 158.802 227.332C183.004 227.332 205.443 217.994 223.894 202.073",
    stroke: "#424242",
    strokeWidth: 19.2958,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_92_7865",
    x: 23.7194,
    y: 136.234,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_92_7865",
    x: 143.167,
    y: 57.5577,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_92_7865",
    x: 239.351,
    y: 35.6113,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_92_7865",
    x: 243.825,
    y: 216.566,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_92_7865",
    x: 132.43,
    y: 166.462,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_92_7865",
    x: 63.9825,
    y: 24.431,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_92_7865",
    x: 151.667,
    y: 17.8056,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_92_7865",
    x: 44.7456,
    y: 79.5043,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_92_7865",
    x: 111.404,
    y: 246.38,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_92_7865",
    x: 264.403,
    y: 160.251,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_92_7865",
    x: 30.43,
    y: 178.056,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_92_7865",
    x: 99.772,
    y: 0,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_92_7865",
    x: 282.298,
    y: 112.217,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_92_7865",
    x: 183.877,
    y: 249.279,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_92_7865",
    x: 85.4562,
    y: 195.862,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_92_7865",
    x: 190.14,
    y: 94.4113,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_92_7865",
    x: 0.456216,
    y: 93.1689,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_92_7865",
    x: 38.93,
    y: 231.473,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_92_7865",
    x: 119.009,
    y: 97.3098,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_92_7865",
    x: 228.614,
    y: 118.428,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_92_7865",
    x: 77.4036,
    y: 97.3098,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_92_7865",
    x: 151.667,
    y: 207.87,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_92_7865",
    x: 166.877,
    y: 142.445,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_92_7865",
    x: 77.4036,
    y: 147.828,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_92_7865",
    x: 222.351,
    y: 71.2225,
    width: 41.561,
    height: 38.6986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.771831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_7865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_7865",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreckle);
export default __webpack_public_path__ + "static/media/freckle.d97f9c0ac0bf2e7c4375950b45eb293c.svg";
export { ForwardRef as ReactComponent };